import { Component, OnInit, Inject } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpRoleInfo } from '../model/emprole.model';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { TokenService } from '../service/token.service';

let today = new Date().toISOString()


@Component({
  selector: 'app-select-projectsale',
  templateUrl: './select-projectsale.component.html',
  styleUrls: ['./select-projectsale.component.css']
})
export class SelectProjectsaleComponent implements OnInit {


  ProjectSaleOnPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[]

  EmpRoleOnPromise: Promise<EmpRoleInfo[]>
  EmpRoleList: EmpRoleInfo[]


  public currentPageNumber: number
  public totalPages: number
  RoleCode: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }


  async ngOnInit() {
    this.currentPageNumber = 1;

    this.LoadProjectSale();


  }


  ///////////////////////////////////////Functions/////////////////////////////////////////

  LoadProjectSale() {
    this.LoadProjectSaleList()
      .then(
        data => {
          this.ProjectSaleList = data

        }
      )

  }

  async LoadProjectSaleList(): Promise<ProjectSaleInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let EmpCode = "";
      let UserName = "";
      if (typeof (Storage) !== "undefined") {

        EmpCode = localStorage.getItem("EmpCode")
        UserName = localStorage.getItem("UserName")

      }

      //Get Emp Role 
      let strjson = "{\"EmpCode\": \"" + EmpCode + "\" " +
        "}";


      await this.httpClient
        .post<EmpRoleInfo[]>(this.baseurl + "Employee/GetEmployeeRoleCriteria",
          strjson, httpOptions).toPromise()
        .then(
          data => {
            this.EmpRoleList = data

            for (let item of this.EmpRoleList) {

              this.RoleCode = item.RoleCode
            }
          }
        )
      //End  Get Emp Role 
      var objectjson = {};
      if (this.RoleCode == "MANAGER") { // Check หัวหน้าเห็นหมด

      } else {

        objectjson['ProjectSaleMemberEmpCode'] = EmpCode;
      }

      let strjsonGetProjectSaleMember = JSON.stringify(objectjson);

      this.ProjectSaleOnPromise = this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale",
          strjsonGetProjectSaleMember, httpOptions)
        .toPromise()

      return this.ProjectSaleOnPromise;
    }
  }

}
